import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found.component';

import { CoreModule } from './core/core.module';
import { ComponentModule } from './components/component.module';
import { AppConstants } from './app.constant';

import { utModule } from './shell/ut/ut.module';
import { LoginModule } from './login/login.module';
import { UserClientsModule } from './userclients/userclients.module';

import { ToastModule, ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';


// Toaster
const toastOptions: ToastOptions = new ToastOptions({
  animate: 'flyRight',
  positionClass: 'toast-bottom-center',
  showCloseButton: true,
  toastLife: 10000,
  newestOnTop: false,
  dismiss: 'controlled'
});

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    RouterModule,
    CoreModule,
    ComponentModule,
    ToastModule,
    LoginModule,
    UserClientsModule,
    utModule,
    AppRoutingModule
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    AppConstants.injector = injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts